module.exports = __webpack_public_path__ + "img/quickening_charm.e4085920.png";